/**
 * While a phone-flag change is awaiting its replacement legal statement, the
 * statement is briefly null. That would otherwise collapse the widget to its
 * minimum height, and because the applied height and the stored height can then
 * diverge, the consent statement ends up clipped once the (same-sized) statement
 * returns. Holding the height until the refetch resolves avoids that; growth is
 * always allowed, and a non-numeric height is passed through untouched so bad
 * values fall back to the prior behaviour rather than becoming NaN.
 *
 * @param {number} newWidgetHeight - freshly computed required height in px
 * @param {number} currentWidgetHeight - currently applied required height in px
 * @param {boolean} isAwaitingFlagDrivenRefetch - true while a flag refetch is pending
 * @returns {number} the height to apply
 */
const holdWidgetHeightDuringFlagRefetch = (
  newWidgetHeight,
  currentWidgetHeight,
  isAwaitingFlagDrivenRefetch
) => {
  if (!isAwaitingFlagDrivenRefetch) return newWidgetHeight;
  const next = Number(newWidgetHeight);
  const current = Number(currentWidgetHeight);
  if (!Number.isFinite(next) || !Number.isFinite(current)) {
    return newWidgetHeight;
  }
  return Math.max(next, current);
};

export default holdWidgetHeightDuringFlagRefetch;
